var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Product(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 8.33L12 23.15v29.69l26 14.83 26-14.83V23.15L38 8.33zm0 4.6l20.89 11.91-7.63 4.4-21.37-11.68L38 12.93zm-2 49L16 50.52v-22l20 11.54v21.87zM17.38 24.69L25.53 20 47 31.72l-8.71 5-20.91-12.03zM60 50.52l-20 11.4V40.36l8-4.62V46l4-2.5v-10l8-4.63v21.65z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Product.55fda25e.svg";
export { SvgK1Product as ReactComponent };